import React, { useState, useEffect } from "react";
import "./Report.css";
import { useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { FaLongArrowAltLeft } from "react-icons/fa";
import Loading from "../Loader/Loading";
import myImage from "../../assests/183.png";

const Report = () => {
  const [showopenedOptions, setShowopenedOptions] = useState(false);
  const [showclosedOptions, setShowclosedOptions] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const location = useLocation();
  const { vendor = [], subs = [], company = [] } = location.state || {};

  const [isOpen1, setIsOpen1] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [isreportopen, setisreportopen] = useState(false);

  // const [currentPageOpened, setCurrentPageOpened] = useState(1);
  // const [currentPageClosed, setCurrentPageClosed] = useState(1);
  const rowsPerPage = 10;

  const userDetails = JSON.parse(localStorage.getItem("userdetails"));

  const Navigate = useNavigate();

  // const openedTickets = filterdata.filter(
  //   (filterdata) => filterdata.status !== "Closed"
  // );

  // const closedTickets = filterdata.filter(
  //   (ticket) => ticket.status === "Closed"
  // );

  // const filteredOpenedTickets = openedTickets.filter((filterdata) => {
  //   return userDetails.role === "cmanager"
  //     ? filterdata.client_id?.toString() === userDetails.clientid?.toString()
  //     : true;
  // });

  // const totalPagesOpened = Math.ceil(
  //   filteredOpenedTickets.length / rowsPerPage
  // );
  // const startIndexOpened = (currentPageOpened - 1) * rowsPerPage;
  // const currentRowsOpened = filteredOpenedTickets.slice(
  //   startIndexOpened,
  //   startIndexOpened + rowsPerPage
  // );

  // const filteredClosedTickets = closedTickets.filter((ticket) => {
  //   return userDetails.role === "cmanager"
  //     ? ticket.client_id?.toString() === userDetails.clientid?.toString()
  //     : true;
  // });

  // const totalPagesClosed = Math.ceil(
  //   filteredClosedTickets.length / rowsPerPage
  // );
  // const startIndexClosed = (currentPageClosed - 1) * rowsPerPage;
  // const currentRowsClosed = filteredClosedTickets.slice(
  //   startIndexClosed,
  //   startIndexClosed + rowsPerPage
  // );

  // const filteredSupportOptions = clientlist.filter((item) =>
  //   item.client_code.toLowerCase().includes(searchTermSupport.toLowerCase())
  // );

  //  cc
  const [Reports, setreports] = useState({ year: "", month: "" });
  const [NotUploadvendor, setNotUploadvendor] = useState([]);
  const [Uploadvendor, setUploadvendor] = useState([]);
  const [months] = useState([
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ]);
  const years = Array.from({ length: 5 }, (_, i) => 2024 + i);

  const handlehomepage = () => {
    Navigate("/Admin");
  };

  const [currentPageClosed, setCurrentPageClosed] = useState(1);
  const [currentPageOpened, setCurrentPageOpened] = useState(1);
  const [itemsPerPage] = useState(10);

  const startIndexClosed = (currentPageClosed - 1) * itemsPerPage;
  const endIndexClosed = startIndexClosed + itemsPerPage;
  const paginatedNotUploadvendor = NotUploadvendor.slice(
    startIndexClosed,
    endIndexClosed
  );
  const totalPagesClosed = Math.ceil(NotUploadvendor.length / itemsPerPage);

  const startIndexOpened = (currentPageOpened - 1) * itemsPerPage;
  const endIndexOpened = startIndexOpened + itemsPerPage;
  const paginatedUploadvendor = Uploadvendor.slice(
    startIndexOpened,
    endIndexOpened
  );
  const totalPagesOpened = Math.ceil(Uploadvendor.length / itemsPerPage);

  const fetchvendorsreport = async () => {
    if (!Reports.year || !Reports.month) {
      alert("Please Select Both Year and Month");
      return;
    }
    setisreportopen(true);

    const formData = new FormData();
    formData.append("year", Reports.year);
    formData.append("month", Reports.month);
    formData.append("user_id", Reports.vendor || "");
    formData.append("sub", subs?.subscriber_id || "");

    try {
      const base = company ? "vendors" : "clients";
      const response = await fetch(
        `${process.env.REACT_APP_BASEURL}/apis/${base}/report.php`,
        {
          method: "POST",
          body: formData,
        }
      );

      if (!response.ok)
        throw new Error(`HTTP error! Status: ${response.status}`);

      const data = await response.json();
      setUploadvendor(data.data || []);
      setNotUploadvendor(data.data1 || []);
      // Do NOT update chartData here so the pie chart remains from notupload API
    } catch (error) {
      console.error("Error fetching uploaded clients:", error);
      // setUploadClient([]);
    }
  };

  const handlereportopened = async (type) => {
    // Validate required fields

    if (!Reports.year || !Reports.month) {
      alert("Please Select Both Year and Month");
      return;
    }
    {
      const userId = encodeURIComponent(Reports.vendor || "");
      const year = encodeURIComponent(Reports.year);
      const month = encodeURIComponent(Reports.month);

      const fileType = type === "pdf" ? "pdf" : "csv";
      const base = company ? "vendors" : "clients";
      const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/${base}/reportupload.php?user_id=${userId}&year=${year}&month=${month}&type=${fileType}`;

      try {
        const response = await fetch(apiUrl, {
          method: "GET",
        });

        const contentType = response.headers.get("Content-Type");

        if (!response.ok || !contentType.includes(fileType)) {
          const text = await response.text();
          console.error("Unexpected response:", text);
          alert("No data or wrong format returned.");
          return;
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `report-${year}-${month}.${fileType}`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        console.error("Download error:", error);
        alert("There was an error downloading the report.");
      }
    }
  };

  const handlereportclosed = async (type) => {
    if (!Reports.year || !Reports.month) {
      alert("Please Select Both Year and Month");
      return;
    }
    {
      const userId = encodeURIComponent(Reports.vendor || "");
      const year = encodeURIComponent(Reports.year);
      const month = encodeURIComponent(Reports.month);
      const sub = encodeURIComponent(subs?.subscriber_id || "");

      const fileType = type === "pdf" ? "pdf" : "csv";
      const base = company ? "vendors" : "clients";
      const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/${base}/reportnotupload.php?user_id=${userId}&year=${year}&month=${month}&type=${fileType}&sub=${sub}`;

      // const apiUrl = `${process.env.REACT_APP_BASEURL}/apis/reportclose.php?id=${userId}&assignedto_id=${supportId}&client_name=${clientId}&start_date=${startDate}&end_date=${endDate}&type=${fileType}`;

      try {
        const response = await fetch(apiUrl, {
          method: "GET",
        });

        const contentType = response.headers.get("Content-Type");

        if (!response.ok || !contentType.includes(fileType)) {
          const text = await response.text();
          console.error("Unexpected response:", text);
          alert("No data or wrong format returned.");
          return;
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `report-${year}-${month}.${fileType}`);
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        console.error("Download error:", error);
        alert("There was an error downloading the report.");
      }
    }
  };

  return (
    <>
      <div className="align">
        <button className="button" onClick={handlehomepage}>
          <svg>
            <FaLongArrowAltLeft />
          </svg>
          <div className="text">Home</div>
        </button>
      </div>
      <div className="report-layout">
        {/* <div className="sidebar">
          <h3>Selected Filters</h3>
          {submittedFilters ? (
            <ul className="filter-badges">
              {Object.entries(submittedFilters).map(([key, value]) => {
                if (!value) return null;
                const displayValue = value.label || value;
                return (
                  <li key={key} className="filter-badge">
                    <div>
                      <strong>{labelMap[key] || key}:</strong> {displayValue}
                    </div>
                    <button
                      className="remove-filter-btn"
                      onClick={() => handleRemoveFilter(key)}
                    >
                      &minus;
                    </button>
                  </li>
                );
              })}
            </ul>
          ) : (
            <p>No filters applied</p>
          )}
        </div> */}

        {/* specs  */}
        <div className="report-container">
          <h2 className="head">Report</h2>

          <div className="filter-section">
            <div className="reports">
              <div className="form-group">
                {company ? (
                  <label htmlFor="vendor">Vendors</label>
                ) : (
                  <label htmlFor="vendor">Clients</label>
                )}
                <select
                  id="vendor"
                  className="form-control"
                  value={Reports?.vendor}
                  onChange={(e) =>
                    setreports((prev) => ({
                      ...prev,
                      vendor: e.target.value,
                    }))
                  }
                >
                  {company ? (
                    <option value={""} disabled selected>
                      Select Vendor
                    </option>
                  ) : (
                    <option value={""} disabled selected>
                      Select Client
                    </option>
                  )}
                  {vendor?.length > 0 ? (
                    vendor.map((row) => (
                      <option value={row?.user_id}>{row?.username}</option>
                    ))
                  ) : (
                    <>
                      {company ? (
                        <option value="" disabled>
                          No vendors
                        </option>
                      ) : (
                        <option value="" disabled>
                          No clients
                        </option>
                      )}
                    </>
                  )}
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="year">Year</label>
                <select
                  id="year"
                  className="form-control"
                  value={Reports?.year}
                  onChange={(e) =>
                    setreports((prev) => ({
                      ...prev,
                      year: e.target.value,
                    }))
                  }
                >
                  <option value="" disabled>
                    Select Year
                  </option>
                  {years.map((year) => (
                    <option key={year} value={year}>
                      {year}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label htmlFor="month">Month</label>
                <select
                  id="month"
                  className="form-control"
                  value={Reports?.month}
                  onChange={(e) =>
                    setreports((prev) => ({
                      ...prev,
                      month: e.target.value,
                    }))
                  }
                >
                  <option value="" disabled>
                    Select Month
                  </option>
                  {months.map((month, index) => (
                    <option key={index} value={month}>
                      {month}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          <div className="download-buttons">
            <div className="btn-submit-outer">
              <button
                className="btn-submit"
                // onClick={() => (handleSubmit(), setisreportopen(true))}
                onClick={fetchvendorsreport}
              >
                Submit
              </button>
            </div>
          </div>

          {/* {isLoading && <Loading type="report" />} */}

          {isreportopen &&
            (Uploadvendor.length === 0 && NotUploadvendor.length === 0 ? (
              <>
                <div className="images">
                  <img src={myImage} alt="Description" />
                  {company ? (
                    <div className="notickets">
                      🔍 No Vendors found for the Matching Result.
                    </div>
                  ) : (
                    <div className="notickets">
                      🔍 No Clients found for the Matching Result.
                    </div>
                  )}
                </div>
              </>
            ) : (
              <>
                {/* notuploads  */}
                {/* NOT UPLOAD VENDOR TABLE */}
                <div>
                  <h4
                    style={{
                      fontSize: "20px",
                      fontWeight: "600",
                      marginBottom: "10px",
                      color: "#333",
                      padding: "20px 5px",
                    }}
                  >
                    {company ? "PENDING VENDOR" : "PENDING Clients"}
                  </h4>
                  <div
                    className="download-wrapper"
                    onClick={() => setShowclosedOptions(true)}
                    onMouseLeave={() => setShowclosedOptions(false)}
                  >
                    <button className="downbtn">Download</button>
                    {showclosedOptions && (
                      <div className="download-actions">
                        <button onClick={() => handlereportclosed("pdf")}>
                          PDF
                        </button>
                        <button onClick={() => handlereportclosed("csv")}>
                          Excel
                        </button>
                      </div>
                    )}
                  </div>

                  <table className="report-table">
                    <thead>
                      <tr>
                        <th>SI.NO</th>
                        {company ? (
                          <>
                            <th>Vendor Name</th>
                            <th>Vendor Code</th>
                          </>
                        ) : (
                          <>
                            <th>Client Name</th>
                            <th>Client Code</th>
                          </>
                        )}
                        <th>User Name</th>
                        <th>Email</th>
                      </tr>
                    </thead>
                    <tbody>
                      {paginatedNotUploadvendor.length > 0 ? (
                        paginatedNotUploadvendor.map((item, index) => (
                          <tr key={item.id}>
                            <td>{startIndexClosed + index + 1}.</td>
                            <td>{item.name}</td>
                            <td>{item.code}</td>
                            <td>{item.username}</td>
                            <td>{item.email}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5">No data found</td>
                        </tr>
                      )}
                    </tbody>
                  </table>

                  {totalPagesClosed > 1 && (
                    <div className="pagination-controls">
                      <h2>
                        Page {currentPageClosed} of {totalPagesClosed}
                      </h2>
                      <div className="pagination-buttons">
                        {currentPageClosed !== 1 && (
                          <>
                            <button onClick={() => setCurrentPageClosed(1)}>
                              &laquo; First
                            </button>
                            <button
                              onClick={() =>
                                setCurrentPageClosed((prev) =>
                                  Math.max(prev - 1, 1)
                                )
                              }
                            >
                              &lt; Prev
                            </button>
                          </>
                        )}
                        {currentPageClosed !== totalPagesClosed && (
                          <>
                            <button
                              onClick={() =>
                                setCurrentPageClosed((prev) =>
                                  Math.min(prev + 1, totalPagesClosed)
                                )
                              }
                            >
                              Next &gt;
                            </button>
                            <button
                              onClick={() =>
                                setCurrentPageClosed(totalPagesClosed)
                              }
                            >
                              Last &raquo;
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  )}
                </div>

                {/* UPLOAD VENDOR  */}
                {/* UPLOAD VENDOR TABLE */}
                <div>
                  <>
                    <h4
                      style={{
                        fontSize: "20px",
                        fontWeight: "600",
                        marginBottom: "10px",
                        color: "#333",
                        padding: "20px 5px",
                      }}
                    >
                      UPLOAD VENDOR
                    </h4>
                    <div
                      className="download-wrapper"
                      onClick={() => setShowopenedOptions(true)}
                      onMouseLeave={() => setShowopenedOptions(false)}
                    >
                      <button className="downbtn">Download</button>
                      {showopenedOptions && (
                        <div className="download-actions">
                          <button onClick={() => handlereportopened("pdf")}>
                            PDF
                          </button>
                          <button onClick={() => handlereportopened("csv")}>
                            Excel
                          </button>
                        </div>
                      )}
                    </div>

                    <table className="report-table">
                      <thead>
                        <tr>
                          <th>SI.NO</th>
                          {company ? (
                            <th>Vendor Name</th>
                          ) : (
                            <th>Client Name</th>
                          )}
                          <th>Type</th>
                          <th>Act</th>
                          <th>Form</th>
                          <th>Frequency</th>
                          <th>File</th>
                          {company ? <th>Download By</th> : <th>Upload By</th>}
                        </tr>
                      </thead>
                      <tbody>
                        {paginatedUploadvendor.length > 0 ? (
                          paginatedUploadvendor.map((item, index) => (
                            <tr key={item.id}>
                              <td>{startIndexOpened + index + 1}.</td>
                              <td>{item.name}</td>
                              <td>{item.type}</td>
                              <td>{item.act}</td>
                              <td>{item.forms}</td>
                              <td>{item.frequency}</td>
                              <td>{item.file}</td>
                              {company ? (
                                <td>{item.username}</td>
                              ) : (
                                <td>{item.upload_by}</td>
                              )}
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan="9">No data found</td>
                          </tr>
                        )}
                      </tbody>
                    </table>

                    {totalPagesOpened > 1 && (
                      <div className="pagination-controls">
                        <h2>
                          Page {currentPageOpened} of {totalPagesOpened}
                        </h2>
                        <div className="pagination-buttons">
                          {currentPageOpened !== 1 && (
                            <>
                              <button onClick={() => setCurrentPageOpened(1)}>
                                &laquo; First
                              </button>
                              <button
                                onClick={() =>
                                  setCurrentPageOpened((prev) =>
                                    Math.max(prev - 1, 1)
                                  )
                                }
                              >
                                &lt; Prev
                              </button>
                            </>
                          )}
                          {currentPageOpened !== totalPagesOpened && (
                            <>
                              <button
                                onClick={() =>
                                  setCurrentPageOpened((prev) =>
                                    Math.min(prev + 1, totalPagesOpened)
                                  )
                                }
                              >
                                Next &gt;
                              </button>
                              <button
                                onClick={() =>
                                  setCurrentPageOpened(totalPagesOpened)
                                }
                              >
                                Last &raquo;
                              </button>
                            </>
                          )}
                        </div>
                      </div>
                    )}
                  </>
                </div>
              </>
            ))}
        </div>
      </div>
    </>
  );
};

export default Report;
